module.exports = __webpack_public_path__ + "static/img/siswa-baru.8c19a8f6.svg";